import {Component, ElementRef, forwardRef, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {CheckboxSelectionState} from "../utils";
import {AbstractValueAccessorComponent} from "../component/value-accessor.component";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
    selector: 'app-selection-checkbox',
    templateUrl: './selection-checkbox.component.html',
    styleUrls: ['./selection-checkbox.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SelectionCheckboxComponent), multi: true }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SelectionCheckboxComponent extends AbstractValueAccessorComponent<CheckboxSelectionState> {
  inputValue: CheckboxSelectionState;

  @ViewChild("inputEl") inputEl: ElementRef;

  // model -> view only. MUST NOT emit: this is the programmatic push from Angular during change
  // detection. Emitting here echoes the value straight back out as if the user changed it, which -
  // combined with a signal-backed parent setter - creates an infinite change-detection loop.
  writeValue(value: CheckboxSelectionState): void {
    this.inputValue = value;
    if (this.inputEl) {
      this.inputEl.nativeElement.indeterminate = value === CheckboxSelectionState.indeterminate;
    }
  }

  get value(): CheckboxSelectionState {
    return this.inputValue;
  }

  get selected(): boolean {
    return this.inputValue === CheckboxSelectionState.selected;
  }

  // view -> model. Triggered ONLY by a genuine user click on the inner checkbox, so this is the
  // correct place to propagate the change out via onModelChange().
  set selected(selected: boolean) {
    this.inputValue = selected ? CheckboxSelectionState.selected : CheckboxSelectionState.unselected;
    this.onModelChange();
  }
}
